// v6 F3.5b — Client-side TaxRegime constants + labels.
// Bron van waarheid blijft backend /api/tax-regimes; deze constants zijn
// UI-fallbacks + typing hint. Labels moeten identiek zijn aan backend.

export const TAX_REGIME_KEYS = ["standard", "reduced_renovation", "reverse_charge"];

export const TAX_REGIME_LABELS = {
  standard: "Standaard BTW",
  reduced_renovation: "Renovatie 6%",
  reverse_charge: "BTW verlegd",
};

export const TAX_REGIME_HINTS = {
  standard: "Standaard BTW-tarieven (21% / 6% / 0%) per lijn.",
  reduced_renovation: "Verlaagd tarief 6% voorgesteld — mixed tarieven blijven mogelijk per lijn.",
  reverse_charge: "BTW verlegd naar medecontractant. Factuur toont 0% en juridische mededeling.",
};

export function regimeLabel(key) {
  return TAX_REGIME_LABELS[key] || TAX_REGIME_LABELS.standard;
}
